export const ALLOWED_FILE_EXTENSIONS = ['.pem', '.crt', '.crs', '.cer'];
export const CERTIFICATE_ERROR_MESSAGES = {
  invalid: 'Invalid Certificate Extension',
  alreadyExists: 'This certificate already exists',
  invalidCertificate: 'Unable to load certificate. Please verify the file and try again',
};
